import { Button } from 'antd';
import Toast from 'components/Toast';
import API from 'utils/API';
import downloadFile from 'utils/DownloadFile';
import pdfIcon from './images/pdfIcon.png';
import './style.scss';

interface IDocumentItemProps {
    description: string;
    id: string;
}

const DocumentItem: React.FC<IDocumentItemProps> = ({ description, id }) => {
    const handleDownloadFile = async () => {
        Toast.loading(true);

        try {
            await downloadFile(API.TRADE.viewDoc.downloadDoc(id), {}, description, 'pdf');
        } catch (error) {
            Toast.show(error);
        }

        Toast.loading(false);
    };

    return (
        <div className="document-item-root">
            <div className="document-item-wrap">
                <img src={pdfIcon} alt={description} className="document-item-img" />
                <div className="document-item-description">{description}</div>
            </div>
            <Button onClick={handleDownloadFile} type="link">
                {__('Download')}
            </Button>
        </div>
    );
};

export default DocumentItem;
